import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { su } from '../../../theme/functions/su';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { Battery } from '../../../components/common/Battery';

const table = styled.table`
  text-align: start;
  border-collapse: collapse;
  width: 100%;
  font-size: ${theme.fontSize.small};
  border-radius: ${theme.borderRadius.default};
`;

const tbody = styled.tbody`
  transition: ${motion.transition.micro};
  border-top: 2px solid ${theme.color.line_light};

  td:nth-of-type(1):not(:first-of-type),
  td:nth-of-type(2):not(:first-of-type) {
    cursor: pointer;
  }
`;
const thead = styled.thead`
  background: ${theme.color.component};
  box-shadow: ${theme.boxShadow.scroll};
  transition: ${motion.transition.micro};
  font-weight: ${theme.fontWeight.medium};
`;

const col = styled.col`
  transition: ${motion.transition.micro};
  ${(props) =>
    props.isHover &&
    css`
      background-color: ${theme.color.background_hover};
    `};
`;

const tr = styled.tr`
  cursor: default;
  color: var(--color, ${theme.color.mono_700});
`;

const th = styled.th`
  padding: ${su(0.25, 1)};
  transition: ${motion.transition.micro};
  width: 1%;
  white-space: nowrap;
  cursor: not-allowed;
  height: ${su(5)};

  &:nth-last-of-type(2),
  &:last-child {
    width: auto;
    padding: 0;
  }

  ${(props) =>
    props.sortable &&
    css`
      cursor: pointer;
      user-select: none;

      &:hover {
        background-color: ${theme.color.background_hover};
      }
    `};
`;

const td = styled.td`
  border-top: 1px solid ${theme.color.line_light};
  padding: ${su(0.25, 1)};

  width: 1%;
  white-space: nowrap;
  height: ${su(5)};

  &:first-of-type {
    min-width: ${su(2)};
  }

  &:nth-last-of-type(2) {
    min-width: auto;
    width: auto;
  }

  &:last-of-type:not(:first-of-type) {
    position: sticky;
    right: 0;
    min-width: auto;
    padding-top: 0;
    padding-bottom: 0;
    text-align: end;
    background-clip: padding-box;

    &:lang(ar) {
      right: unset;
      left: 0;
    }
  }

  ${Battery.Root} {
    margin-inline-end: ${su(1)};
  }
`;

export const Table = { table, thead, col, tbody, tr, th, td };
